module.exports = __webpack_public_path__ + "img/advertising-free.e6196de.png";